import { DEFAULT_FILE_SHARING_LIMITS } from '@andor/contracts/settings';
import { AppConfig } from '../schemas/settings';

export const configDefault: AppConfig = {
  title: 'ODIN :: Rooms',
  gateway: 'gateway.odin.4players.io',
  colorMode: 'dark',
  developerMode: false,
  fileSharing: { ...DEFAULT_FILE_SHARING_LIMITS },
  assets: {
    darkLogo: {
      url: '/assets/logo_dark.svg',
    },
    lightLogo: {
      url: '/assets/logo_light.svg',
    },
    darkBackground: {
      url: '/assets/bg_signal_golem_dark.webp',
    },
    lightBackground: {
      url: '/assets/bg_signal_golem_light.webp',
    },
  },
  styles: [
    {
      id: '--primary-color',
      dark: '0,0,0',
      light: '253,253,253',
    },
    {
      id: '--accent-color',
      dark: '24,229,131',
      light: '14,124,71',
    },
    {
      id: '--contrast-color',
      dark: '0,0,0',
      light: '255,255,255',
    },
  ],
};
